export default "__VITE_ASSET__B07Dr9FQ__"